import { string } from 'prop-types';

const materialBasicInformationPropTypes = {
  name: string.isRequired,
  externalId: string.isRequired,
  measurementUnit: string.isRequired,
};

export default materialBasicInformationPropTypes;
